import axios, { AxiosPromise } from 'axios';

export const FETCH_FEATURE_FLAG = 'FETCH_FEATURE_FLAG';
export const FETCH_FEATURE_FLAG_FULFILLED = `${FETCH_FEATURE_FLAG}_FULFILLED`;
export const FETCH_FEATURE_FLAG_REJECTED = `${FETCH_FEATURE_FLAG}_REJECTED`;

interface AxiosPromiseResponse {
  data: any;
}

interface GetFeatureFlagsAction {
  type: string;
  payload: AxiosPromise<AxiosPromiseResponse>;
}

export interface GetFeatureFlagsActionResponse {
  type: string;
  payload: AxiosPromiseResponse;
}

export function getFeatureFlags(): GetFeatureFlagsAction {
  return {
    type: FETCH_FEATURE_FLAG,
    payload: axios.get(`${process.env.REACT_APP_FEATURE_FLAG_ENDPOINT}`),
  };
}
